import Layout from '@/layout/home.vue'

export{
    Layout,
}
